import React              from 'react';
import { useTranslation } from 'react-i18next';
import TextField          from '@material-ui/core/TextField';
import PropTypes          from 'prop-types';

const OSCPUSelector = ({ value, setValue, disabled = false, required = false, ...rest }) => {
	const { t } = useTranslation();

	return (
		<TextField
			label={t('custom_os_cpu_label')}
			helperText={t('custom_os_cpu_helperText')}
			value={value}
			onChange={e => setValue(e.target.value)}
			select
			fullWidth
			InputLabelProps={{ shrink: !!value }}
			disabled={disabled}
			required={required}
			variant='outlined'
			SelectProps={{
				native: true
			}}
			{...rest}
		>
			<option/>
			<option value='x86_64'>{t('custom_os_cpu_x86_64')}</option>
			<option value='arm64'>{t('custom_os_cpu_arm64')}</option>
		</TextField>
	);
};

export default OSCPUSelector;

OSCPUSelector.propTypes = {
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	setValue: PropTypes.func.isRequired,
	value: PropTypes.string
};
